module.exports = __webpack_public_path__ + "static/media/arrow-up.14d73af3.svg";